// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const CardWrapper = styled.div<{ isDark: boolean }>(
  ({ isDark }) => css`
    width: 100%;
    height: 100%;
    box-shadow: ${
      isDark
        ? 'none'
        : '0px 0px 16px rgba(195, 203, 214, 0.16), 0px 1px 4px rgba(195, 203, 214, 0.16)'
    };
    border-radius: 10px;
  `,
);

export const PreviewContainer = styled.a<{ isStudios: boolean }>(
  ({ isStudios }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    cursor: default;

    .player,
    .tag {
      opacity: 1;
    }
    .helper {
      opacity: 0;
    }

    ${
      !isStudios &&
      css`
      cursor: pointer;
      background: linear-gradient(0deg, #181b32 0%, rgba(24, 27, 50, 0) 100%);
      :hover {
        .player,
        .tag {
          opacity: 0;
        }
        .helper {
          opacity: 1;
        }
      }
    `
    }
  `,
);

export const PlayerWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    position: absolute;
    border-radius: 100%;
    background-color: ${theme.colors.gray['dark-70']};
    transition: ${theme.transition('opacity')};
  `,
);

export const HelperWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.base['main-80']};
    border-radius: 10px;
    cursor: pointer;
    transition: ${theme.transition('opacity')};
  `,
);

export const TagWrapper = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: 11px;
    left: 14px;
    transition: ${theme.transition('opacity')};
  `,
);
